(function () {
  if (window.__tuneMotion) return;
  window.__tuneMotion = true;

  function init(root) {
    if (root.__tuneInit) return;
    root.__tuneInit = true;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var EASE = 'cubic-bezier(0.16, 1, 0.3, 1)';

    var btns = root.querySelectorAll('[data-acc]');
    function setOpen(idx) {
      btns.forEach(function (b) {
        var i = b.getAttribute('data-acc');
        var open = i === idx;
        var body = root.querySelector('[data-acc-body="' + i + '"]');
        var img = root.querySelector('[data-acc-img="' + i + '"]');
        var icon = b.querySelector('[data-acc-icon]');
        if (body) body.style.display = open ? '' : 'none';
        if (img) img.style.display = open ? '' : 'none';
        if (icon) icon.textContent = open ? '\u2212' : '+';
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { setOpen(b.getAttribute('data-acc')); });
    });

    if (reduce) return;

    var delays = new Map();
    root.querySelectorAll('[data-anim]').forEach(function (el) { delays.set(el, 0); });
    root.querySelectorAll('[data-anim-stagger]').forEach(function (g) {
      Array.prototype.forEach.call(g.children, function (el, i) { delays.set(el, Math.min(i * 90, 540)); });
    });
    delays.forEach(function (_, el) { el.style.opacity = '0'; });

    var bars = root.querySelectorAll('[data-bar]');
    bars.forEach(function (el) { el.setAttribute('data-tw', el.style.width); el.style.width = '0%'; });
    var counts = root.querySelectorAll('[data-count]');

    function reveal(el, delay) {
      el.style.opacity = '';
      el.animate(
        [{ opacity: 0, transform: 'translateY(26px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 850, easing: EASE, delay: delay, fill: 'backwards' }
      );
    }
    function runBar(el, delay) {
      el.style.transition = 'width 1.1s ' + EASE + ' ' + delay + 'ms';
      requestAnimationFrame(function () { el.style.width = el.getAttribute('data-tw'); });
    }
    function runCount(el) {
      var target = parseFloat(el.getAttribute('data-count'));
      var dec = target % 1 !== 0;
      var node = el.firstChild;
      var t0 = performance.now();
      function tick(now) {
        var p = Math.min((now - t0) / 1300, 1);
        var e = 1 - Math.pow(1 - p, 3);
        node.nodeValue = dec ? (target * e).toFixed(1) : String(Math.round(target * e));
        if (p < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target;
        if (delays.has(el)) reveal(el, delays.get(el));
        if (el.hasAttribute('data-bar')) {
          var sibs = Array.prototype.slice.call(el.parentElement.querySelectorAll('[data-bar]'));
          runBar(el, Math.max(0, sibs.indexOf(el)) * 70);
        }
        if (el.hasAttribute('data-count')) runCount(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });

    delays.forEach(function (_, el) { io.observe(el); });
    bars.forEach(function (el) { io.observe(el); });
    counts.forEach(function (el) { io.observe(el); });

    var par = root.querySelector('[data-parallax]');
    if (par) {
      var ticking = false;
      var onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          var r = par.getBoundingClientRect();
          var c = (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight;
          par.style.transform = 'translateY(' + (c * -30).toFixed(1) + 'px)';
          ticking = false;
        });
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  function boot() {
    document.querySelectorAll('[data-tune-motion]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-tune-motion]');
    if (r) init(r);
  });
})();
